

<template>
  <!-- {{ $route.path }} -->

  <div class="sidebar">
    <!-- Logo Section -->
    <div class="logo-section">
      <div class="logo-edit-btn">
        <font-awesome-icon 
          :icon="['fas', 'pen']" 
          class="edit-icon"
          data-bs-toggle="modal" 
          data-bs-target="#editlogoModal" 
        />
      </div>
      <div class="logo-container">
        <img :src="pathLogo" height="60" alt="Logo" class="logo-img">
      </div>
    </div>
    <!-- Navigation Menu -->
    <ul class="nav-menu">
       <!-- group Section (Admin Only) -->
       <div class="menu-section" v-if="['Admin', 'Owner'].includes(userInfo.role)">
        <div class="section-header">
          <div class="section-title">
            <font-awesome-icon :icon="['fas', 'microchip']" class="section-icon" />
            group
          </div>
          <div class="section-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="toggle-icon" />
          </div>
        </div>
        
        <div class="menu-items">
          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/group/list' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'list']" />
              </div>
              <router-link class="btn-link" to="/settings/group/list">
                List group
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/group/create' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </div>
              <router-link class="btn-link" to="/settings/group/create">
                Add group
              </router-link>
            </div>
          </button>

         

        </div>
      </div>
      <!-- plan Section (Admin Only) -->
      <div class="menu-section" v-if="['Admin', 'Owner'].includes(userInfo.role)">
        <div class="section-header">
          <div class="section-title">
            <font-awesome-icon :icon="['fas', 'microchip']" class="section-icon" />
            plan
          </div>
          <div class="section-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="toggle-icon" />
          </div>
        </div>
        
        <div class="menu-items">
          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/plan/list' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'list']" />
              </div>
              <router-link class="btn-link" to="/settings/plan/list">
                List plan
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/plan/create' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </div>
              <router-link class="btn-link" to="/settings/plan/create">
                Add plan
              </router-link>
            </div>
          </button>

         

        </div>
      </div>
      <!-- Devices Section (Admin Only) -->
      <div class="menu-section" v-if="['Admin', 'Owner'].includes(userInfo.role)">
        <div class="section-header">
          <div class="section-title">
            <font-awesome-icon :icon="['fas', 'microchip']" class="section-icon" />
            Devices
          </div>
          <div class="section-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="toggle-icon" />
          </div>
        </div>
        
        <div class="menu-items">
          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/device/list' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'list']" />
              </div>
              <router-link class="btn-link" to="/settings/device/list">
                List Devices
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/device/create' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'plus-circle']" />
              </div>
              <router-link class="btn-link" to="/settings/device/create">
                Add Device
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/device/templatecreate' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'puzzle-piece']" />
              </div>
              <router-link class="btn-link" to="/settings/device/templatecreate">
                Create Template
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/device/listtemplate' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'clipboard-list']" />
              </div>
              <router-link class="btn-link" to="/settings/device/listtemplate">
                List Templates
              </router-link>
            </div>
          </button>
        </div>
      </div>

      <!-- Users Section (Admin Only) -->
      <div class="menu-section" v-if="['Admin', 'Owner'].includes(userInfo.role)">
        <div class="section-header">
          <div class="section-title">
            <font-awesome-icon :icon="['fas', 'users']" class="section-icon" />
            Users
          </div>
          <div class="section-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="toggle-icon" />
          </div>
        </div>
        
        <div class="menu-items">
          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/user/listuser' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'address-book']" />
              </div>
              <router-link class="btn-link" to="/settings/user/listuser">
                List Users
              </router-link>
            </div>
          </button>

          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/user/createuser' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'user-plus']" />
              </div>
              <router-link class="btn-link" to="/settings/user/createuser">
                Add User
              </router-link>
            </div>
          </button>
        </div>
      </div>

      <!-- Info Section -->
      <div class="menu-section">
        <div class="section-header">
          <div class="section-title">
            <font-awesome-icon :icon="['fas', 'info-circle']" class="section-icon" />
            Info
          </div>
          <div class="section-toggle">
            <font-awesome-icon :icon="['fas', 'chevron-down']" class="toggle-icon" />
          </div>
        </div>
        
        <div class="menu-items">
          <button 
            :class="['menu-btn', { 'active': $route.path === '/settings/info' }]"
            type="button"
          >
            <div class="btn-content">
              <div class="btn-icon">
                <font-awesome-icon :icon="['fas', 'user-circle']" />
              </div>
              <router-link class="btn-link" to="/settings/info">
                User Info
              </router-link>
            </div>
          </button>
        </div>
      </div>

      <!-- Dynamic Menu Items -->
      <li v-for="(item, index) in menuItems" :key="index" class="dynamic-menu-item">
        <div class="btn-content">
          <div class="btn-icon">
            <font-awesome-icon :icon="['fas', 'cloud']" />
          </div>
          <router-link 
            :to="settingsitem.path" 
            class="btn-link" 
            active-class="active-link"
          >
            {{ item.name }}
          </router-link>
        </div>
      </li>
    </ul>

    <!-- User Profile Section -->
    <div class="user-profile-section">
      <!-- <div class="user-info">
        <div class="user-avatar">
          <font-awesome-icon :icon="['fas', 'user-circle']" class="avatar-icon" />
        </div>
        <div class="username">{{ userInfo.username }}</div>
      </div> -->
      <div class="text-center py-1 border-0  my-1 bg-white rounded-3">Role: {{ userInfo.role }}</div>
      <button 
        @click="handleLogout" 
        type="button" 
        class="logout-btn"
      >
        <font-awesome-icon :icon="['fas', 'sign-out-alt']" class="logout-icon" />
        Logout
      </button>
    </div>
  </div>

  <!-- Modal (ยังคงเดิม) -->
  <div class="modal fade" id="editlogoModal" tabindex="-1" aria-labelledby="editlogoModalLabel" aria-hidden="true">
    <div class="modal-dialog border-0">
      <div class="modal-content border-0">
        <div class="modal-header">
          <h5 class="modal-title" id="editlogoModalLabel">Edit Logo</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row justify-content-center">
            <div class="container">
              <div>
                <div class="dropzone" @dragover.prevent @drop.prevent="handleDrop" @dragenter.prevent @dragleave.prevent>
                  <input type="file" @change="handleFileUpload" ref="fileInput" hidden accept="image/*" />

                  <div v-if="previewUrl" class="image-preview-container">
                    <img :src="previewUrl" alt="Preview" class="preview-image" />
                    <button class="clear-button" @click.stop="clearImage">✕</button>
                  </div>

                  <div v-else>
                    <p>Drag & Drop your image here</p>
                  </div>
                </div>

                <div class="button-group">
                  <button @click="triggerFileSelect">Choose File</button>
                </div>

                <div v-if="file">
                  <p>Selected File: {{ file.name }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" class="btn btn-primary" @click="uploadFile" data-bs-dismiss="modal">Save changes</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  export default {
    components: {
      // dropzone_com
    },
    data() {
      return {
        pathLogo: "",
        userInfo: {
          username: "",
          role: ""
        },
        selectedFile: null,
        username: '',
        password: '',
        file: null,
        previewUrl: null
      };
    },
    methods: {
      handleLogout() {
        localStorage.clear();
        // Optional: Clear user session/token here
        this.$router.push('/login')
      },
      handleFileUpload(event) {
        const selectedFile = event.target.files[0];
        this.setFile(selectedFile);
      },
      handleDrop(event) {
        const droppedFile = event.dataTransfer.files[0];
        this.setFile(droppedFile);
      },
      setFile(file) {
        if (file && file.type.startsWith("image/")) {
          this.file = file;
          this.previewUrl = URL.createObjectURL(file);
        } else {
          alert("Only image files are allowed!");
          this.clearImage();
        }
      },
      triggerFileSelect() {
        // Allow re-selecting the same file
        this.$refs.fileInput.value = null;
        this.$refs.fileInput.click();
      },
      clearImage() {
        this.file = null;
        this.previewUrl = null;
        this.$refs.fileInput.value = null;
      },
      async uploadFile() {
        if (!this.file) {
          alert("Please select a file first!");
          return;
        }

        const formData = new FormData();
        formData.append("file", this.file);

        try {
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/files/logo`, {
            method: "PUT",
            headers: {
              'Authorization': `Bearer ${accessToken}`
            },
            body: formData
          });

          if (!response.ok) {
            throw new Error(`Upload failed: ${response.statusText}`);
          }
          window.location.reload();
          // const data = await response.json();
          console.log("Upload success:", response);
        } catch (error) {
          console.error("Upload error:", error);
          try {
            // var accessToken = localStorage.getItem("accessToken");
            const response = await fetch(`${process.env.VUE_APP_API_URL}/files/logo`, {
              method: "POST",
              headers: {
                'Authorization': `Bearer ${accessToken}`
              },
              body: formData
            });

            if (!response.ok) {
              throw new Error(`Upload failed: ${response.statusText}`);
            }
            window.location.reload();
            // const data = await response.json();
            console.log("Upload success:", response);
          } catch (error2) {
            console.log(error2)
          }
        }
      },

      async getLogoFileOne() {
        try {
          // this.pathLogo="https://purepng.com/public/uploads/large/purepng.com-disney-logologobrand-logoiconslogos-251519939495wtv86.png"
          var accessToken = localStorage.getItem("accessToken");
          const response = await fetch(`${process.env.VUE_APP_API_URL}/files/logo/get-one`, {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${accessToken}`
            }

          });
          const blob = await response.blob();
          this.pathLogo = URL.createObjectURL(blob);
        } catch (error) {
          console.error("Upload error:", error);
        }
      },

    },
    created() {
      this.getLogoFileOne();
      this.userInfo.username = localStorage.getItem("username");
      this.userInfo.role = localStorage.getItem("role");
    }

  }
</script>
<style scoped>
.sidebar {
  background: #ffffff;
  height: 98vh;
  width: 280px;
  padding: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid #e5e7eb;
  position: relative;
  overflow-y: auto;
}

/* Logo Section */
.logo-section {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  padding: 20px;
  border-bottom: 1px solid #e5e7eb;
  position: relative;
}

.logo-edit-btn {
  position: absolute;
  top: 15px;
  right: 15px;
}

.edit-icon {
  color: #6b7280;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 8px;
  border-radius: 50%;
  background: #f3f4f6;
  border: 1px solid #e5e7eb;
}

.edit-icon:hover {
  color: #374151;
  background: #e5e7eb;
  transform: scale(1.1);
}

.logo-container {
  text-align: center;
  margin-top: 10px;
}

.logo-img {
  border-radius: 12px;
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2); */
  /* transition: transform 0.3s ease; */
}

.logo-img:hover {
  transform: scale(1.05);
}

/* Navigation Menu */
.nav-menu {
  flex: 1;
  padding: 20px 15px;
  list-style: none;
  margin: 0;
  overflow-y: auto;
}

.menu-section {
  margin-bottom: 25px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding: 8px 12px;
  background: #f1f5f9;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
}

.section-title {
  font-weight: 600;
  color: #374151;
  font-size: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.section-icon {
  font-size: 16px;
  color: #6366f1;
}

.section-toggle {
  color: #9ca3af;
}

.toggle-icon {
  font-size: 12px;
  transition: transform 0.3s ease;
}

.toggle-icon:hover {
  transform: rotate(180deg);
}

.menu-items {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-left: 8px;
}

.menu-btn {
  background: transparent;
  border: none;
  padding: 0;
  width: 100%;
  border-radius: 8px;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.menu-btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
  transition: left 0.5s ease;
}

.menu-btn:hover::before {
  left: 100%;
}

.menu-btn:hover {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  transform: translateX(5px);
}

.menu-btn.active {
  background: #c1e7fe;
  border: 1px solid #7dd3fc;
  box-shadow: 0 4px 12px rgba(125, 211, 252, 0.3);
  transform: translateX(5px);
}

.btn-content {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  gap: 12px;
}

.btn-icon {
  width: 20px;
  text-align: center;
  color: #6b7280;
  font-size: 16px;
}

.menu-btn.active .btn-icon {
  color: #0ea5e9;
}

.btn-link {
  text-decoration: none;
  color: #4b5563;
  font-weight: 500;
  font-size: 14px;
  flex: 1;
  text-align: left;
  transition: color 0.3s ease;
}

.menu-btn.active .btn-link {
  color: #0ea5e9;
  font-weight: 600;
}

.btn-link:hover {
  color: #374151;
}

/* Dynamic Menu Items */
.dynamic-menu-item {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 8px;
  margin-bottom: 6px;
  transition: all 0.3s ease;
}

.dynamic-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
  transform: translateX(5px);
}

/* User Profile Section */
.user-profile-section {
  background: rgba(174, 174, 174, 0.2);
  backdrop-filter: blur(10px);
  padding: 5px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: auto;
}

.user-info {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 15px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 12px;
}

.user-avatar {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
}

.avatar-icon {
  font-size: 24px;
  color: white;
}

.username {
  font-weight: 600;
  color: white;
  font-size: 16px;
  flex: 1;
}

.logout-btn {
  width: 100%;
  background: rgba(193, 231, 254, 0.9);
  border: none;
  border-radius: 10px;
  padding: 12px;
  color: #1e40af;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.logout-btn:hover {
  background: rgba(193, 231, 254, 1);
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(193, 231, 254, 0.4);
}

.logout-icon {
  font-size: 16px;
}

/* Scrollbar Styling */
.sidebar::-webkit-scrollbar {
  width: 6px;
}

.sidebar::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.1);
}

.sidebar::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.3);
  border-radius: 3px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.5);
}

/* Responsive */
@media (max-width: 768px) {
  .sidebar {
    width: 260px;
  }
  
  .section-title {
    font-size: 13px;
  }
  
  .btn-link {
    font-size: 13px;
  }
}

/* Modal Styling */
.dropzone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 40px;
  text-align: center;
  transition: all 0.3s ease;
  background: #f8f9fa;
}

.dropzone:hover {
  border-color: #007bff;
  background: #e3f2fd;
}

.image-preview-container {
  position: relative;
  display: inline-block;
}

.preview-image {
  max-width: 200px;
  max-height: 200px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.clear-button {
  position: absolute;
  top: -10px;
  right: -10px;
  background: #dc3545;
  color: white;
  border: none;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  cursor: pointer;
  font-size: 12px;
}

.button-group {
  margin-top: 20px;
  text-align: center;
}

.button-group button {
  background: #007bff;
  color: white;
  border: none;
  padding: 10px 20px;
  border-radius: 5px;
  cursor: pointer;
  transition: background 0.3s ease;
}

.button-group button:hover {
  background: #0056b3;
}
</style>